import { useState } from 'react';
import { Modal, Button, Checkbox } from 'antd';
import InputItem from './InputItem';

export default function AddScoreGroup({ open, onCancel, onSave }) {
  const [name, setName] = useState('');
  const [addBack, setAddBack] = useState(false);

  return (
    <Modal open={open} onCancel={onCancel} footer={null}>
      <div className="flex flex-col gap-2">
        <InputItem
          label="组别"
          require
          options={[{ value: '得分项' }, { value: '扣分项' }]}
          value={name}
          onChange={setName}
        />
        {name === '得分项' && (
          <Checkbox
            checked={addBack}
            onChange={(e) => setAddBack(e.target.checked)}
          >
            存在返程
          </Checkbox>
        )}
        <Button
          key="submit"
          type="primary"
          onClick={() => onSave(name, addBack)}
        >
          保存
        </Button>
      </div>
    </Modal>
  );
}
